// extracted by mini-css-extract-plugin
export var level__img = "level-module--level__img--28272";
export var level__item = "level-module--level__item--1fea9";
export var level__itemImg = "level-module--level__item--img--0be0d";
export var level__list = "level-module--level__list--0dd74";
export var level__name = "level-module--level__name--b017b";
export var level__text = "level-module--level__text--5c68c";
export var level__title = "level-module--level__title--e4916";
export var level__titleDescription = "level-module--level__title-description--2bdb9";
export var level__videoDescr = "level-module--level__video-descr--75c2f";